/* @flow */
// typecheck: ignore file
import React from 'react';
import { Route, IndexRedirect, IndexRoute } from 'react-router';
import chainOnEnter from 'components/lib/chainOnEnter';
import RequireUser from 'components/mixins/RequireUser';
import requireFeatures from 'components/mixins/RequireFeatures';
import AdminLayout from 'admin/components/AdminLayout.jsx';
import AdminLanding from 'admin/components/AdminLanding.jsx';
import AdminPeopleTable from 'admin/components/AdminPeopleTable.jsx';
import AdminClassesTable from 'admin/components/AdminClassesTable.jsx';
import MarketingLayout from 'components/MarketingLayout.jsx';
import SchoolLayout from 'admin/components/SchoolLayout.jsx';
import DistrictLayout from 'admin/components/DistrictLayout.jsx';
import AdminIndex from 'admin/routeHandlers/AdminIndex.jsx';
import AdminSchools from 'admin/components/AdminSchools.jsx';
import SchoolInfomationLayout from 'admin/components/SchoolInfomationLayout.jsx';
import AdminBillingOverview from 'admin/components/AdminBillingOverview.jsx';

const requireAdminWithFeature = chainOnEnter([
  RequireUser,
  requireFeatures(['web_admin_console']),
]);

const LandingLayout = (props) => <MarketingLayout light borderless {...props} />;

// Fetch organizations (if not cached) and redirect to a school or district.
const SchoolIndex = (props) => <AdminIndex schoolRedirect {...props} />;
const DistrictIndex = (props) => <AdminIndex districtRedirect {...props} />;

export default (
  <Route path="/admin" onEnter={requireAdminWithFeature}>
    <IndexRoute component={AdminIndex} />

    <Route component={LandingLayout}>
      <Route path="landing" component={AdminLanding} />
    </Route>

    <Route component={AdminLayout}>
      <Route path="districts">
        <IndexRoute component={DistrictIndex} />
        <Route path=":districtId">
          <Route component={DistrictLayout}>
            <Route path="schools" component={AdminSchools} />
            <Route path="billing" component={AdminBillingOverview} />
            <IndexRedirect to="schools" />
          </Route>
        </Route>
      </Route>

      <Route path="schools">
        <IndexRoute component={SchoolIndex} />
        <Route path=":schoolId">
          <Route component={SchoolLayout}>
            <Route path="information" component={SchoolInfomationLayout}>
              <Route path="classes" component={AdminClassesTable} />
              <Route path="people" component={AdminPeopleTable} />
              <IndexRedirect to="people" />
            </Route>
            <Route path="billing" component={AdminBillingOverview} />
            <IndexRedirect to="information" />
          </Route>
        </Route>
      </Route>
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/admin/routes.js